/**
 * Service for tracking player game related information. It is possible to add to the values being tracked by default.
 */
angular.module('tgaApp').service('gameTrackingService', [
  function () {
    const defaultValues = {
      score: 0,
      questionsAsked: 0,
      questionsCorrect: 0,
      sessionStartTime: 0,
      pausedTime: 0,
      pausedStartTime: 0,
      streak: 0,
      pollCounter: 0,
      uniqueCorrect: [],
    };

    let currentValues = null;

    function reset() {
      const defaultStr = angular.toJson(defaultValues);
      currentValues = angular.fromJson(defaultStr);
      currentValues.sessionStartTime = Date.now();
    }

    function checkInit() {
      if (!currentValues) {
        reset();
      }
    }

    function get() {
      checkInit();
      return currentValues;
    }

    function addKey(key, initVal) {
      checkInit();
      defaultValues[key] = initVal;
      currentValues[key] = initVal;
    }

    function increment(key, val) {
      checkInit();
      currentValues[key] += val;
    }

    function update(key, val) {
      checkInit();
      currentValues[key] = val;
    }

    return ({
      reset,
      get,
      addKey,
      increment,
      update,
    });
  },
]);
